import { render, staticRenderFns } from "./GinUpdate.vue?vue&type=template&id=20569939&scoped=true"
import script from "./GinUpdate.vue?vue&type=script&lang=js"
export * from "./GinUpdate.vue?vue&type=script&lang=js"
import style0 from "./GinUpdate.vue?vue&type=style&index=0&id=20569939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20569939",
  null
  
)

export default component.exports